import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

import { Office } from 'modules/offices';
import * as UI from '../../../ui';
import { HoverConsumer } from '../../../custom-cursor';
import { Map, Locations } from '../../../maps';

import { content } from './content';

import driveryImage from '../../../../../static/images/contacts/img_drivery_logo.svg';

const { DynamicContainer, ContainerType, Text, TextTypes, TitleTypes, Title, LazyLoadContainer } = UI;

const MapSection = ({ styles, rules, office, reference }) => {
    const officeConst = office.toUpperCase();

    const intl = useIntl();
    const { formatMessage } = intl;

    return (
        <DynamicContainer ref={reference} extend={rules.extendMainContainer} dark>
            <LazyLoadContainer lazyLoaded>
                <DynamicContainer isFluid type={ContainerType.GRID} as={ContainerType.SECTION}>
                    <DynamicContainer columns={5}>
                        <Title extend={rules.extendTitle} as={TitleTypes.H3} type={TitleTypes.H1_UPPERCASE}>
                            <FormattedMessage id={content[office].title} />
                        </Title>
                        {office === Office.PRAGUE && (
                            <Text extend={rules.extendText} type={TextTypes.LARGE} as="p">
                                <FormattedMessage id={content[office].description} />
                            </Text>
                        )}
                        {office === Office.BERLIN && (
                            <>
                                {content[office].subtitles.map(item => (
                                    <Title extend={rules.extendSubtitle} type={TitleTypes.H4} key={item.id}>
                                        <FormattedMessage id={item.message} />
                                    </Title>
                                ))}
                                <div className={styles.addressContainer}>
                                    {content[office].address.map(item => (
                                        <Text extend={rules.extendText} key={item.id} type={TextTypes.LARGE} as="p">
                                            <FormattedMessage id={item.message} />
                                        </Text>
                                    ))}
                                </div>
                                <img
                                    alt={formatMessage({ id: content[office].driveryImageAlt })}
                                    className={styles.driveryImage}
                                    src={driveryImage}
                                />
                            </>
                        )}
                    </DynamicContainer>
                    <div className={styles.mapContainer}>
                        <Map center={Locations[officeConst]} office={office} />
                    </div>
                </DynamicContainer>
            </LazyLoadContainer>
        </DynamicContainer>
    );
};

const MapSectionWrapper = props => (
    <HoverConsumer>
        {/* eslint-disable-next-line */}
        {render => <MapSection context={render.context} setContext={render.setContext} {...props} />}
    </HoverConsumer>
);

MapSection.propTypes = {
    styles: PropTypes.shape().isRequired,
    rules: PropTypes.shape().isRequired,
    office: PropTypes.oneOf(Object.values(Office)).isRequired,
    reference: PropTypes.shape(),
};

export default MapSectionWrapper;
